export const NEW = 'new'
export const COMPLETION = 'completion'
export const GENERATION = 'generation'
export const PROCESSING = 'processing'
export const CLOSED = 'closed'
export const CANCELLED = 'cancelled'

export const ALL_REQUEST_LEASE_STATUSES = [
  NEW,
  COMPLETION,
  GENERATION,
  PROCESSING,
  CLOSED,
  CANCELLED,
] as const

export type RequestLeaseStatus = (typeof ALL_REQUEST_LEASE_STATUSES)[number]
